import { FaGraduationCap, FaLeaf, FaMicroscope, FaHandHoldingHeart } from 'react-icons/fa';

export const causes = [
  {
    id: 0,
    name: "Cause and Impact  - General Operations Fund",
    categories: ["nonprofit", "fiscal_sponsorship"],
    state: "Texas",
    stateTag: "TX",
    description: "Support our mission to empower and enable impactful projects through professional fiscal sponsorship, ensuring every dollar creates meaningful change in our communities.",
    shortDescription: "Empowering change through professional fiscal sponsorship.",
    icon: <FaHandHoldingHeart />,
    image: "/images/cause-and-impact.jpg",
    fundsRaised: 0,
    supporters: 0,
    projectsCompleted: 0,
    website: "https://causeandimpact.org",
    impactTiers: [
      {
        level: 5000,
        impact: "Support operational excellence and project onboarding",
        allocation: "Enabling new projects with professional support services"
      },
      {
        level: 15000,
        impact: "Enhance fiscal sponsorship infrastructure",
        allocation: "Improving systems and support for sponsored projects"
      },
      {
        level: 25000,
        impact: "Expand capacity for project support and development",
        allocation: "Growing our ability to serve more impactful initiatives"
      },
      {
        level: 50000,
        impact: "Launch new fiscal sponsorship programs and services",
        allocation: "Creating innovative solutions for nonprofit projects"
      }
    ],
    fallbackPartners: [
      "Project Support Fund",
      "Capacity Building Initiative",
      "Innovation & Growth Fund"
    ],
    updates: [
      {
        id: 1,
        date: "2024-01-15",
        title: "Platform Launch",
        content: "Launching our enhanced fiscal sponsorship platform"
      }
    ]
  },
  {
    id: 1,
    name: "Dyslexia Education & Support Fund",
    categories: ["education", "accessibility"],
    state: "Texas",
    stateTag: "TX",
    description: "Empowering children with dyslexia through access to assistive tools, educational resources, and scholarships, ensuring every child has the opportunity to succeed.",
    shortDescription: "Empowering dyslexic students to thrive.",
    icon: <FaGraduationCap />,
    image: "/images/dyslexia-education.jpg",
    fundsRaised: 0,
    supporters: 0,
    projectsCompleted: 0,
    website: "https://causeandimpact.org/dyslexia",
    impactTiers: [
      {
        level: 5000,
        impact: "Distribute assistive technology grants to 3 classrooms",
        allocation: "3 grants of $1,500 + $500 for admin"
      },
      {
        level: 10000,
        impact: "Provide toolkits and grants for 5 schools, empowering teachers",
        allocation: "5 grants of $1,800 + $500 admin"
      },
      {
        level: 20000,
        impact: "Awareness resources distributed to 50 schools",
        allocation: "$14,500 for awareness + $5,500 admin"
      },
      {
        level: 30000,
        impact: "Award a $25,000 scholarship to a high school student with dyslexia",
        allocation: "$25,000 scholarship + $5,000 admin"
      }
    ],
    fallbackPartners: [
      "International Dyslexia Association",
      "Learning Ally",
      "Made By Dyslexia"
    ],
    updates: [
      {
        id: 1,
        date: "2024-01-15",
        title: "Fund Launch",
        content: "Launching our initiative to support students with dyslexia"
      }
    ]
  },
  {
    id: 2,
    name: "Plant Conservation Fund",
    categories: ["environment", "conservation"],
    state: "Texas",
    stateTag: "TX",
    description: "Protecting and conserving plant biodiversity through awareness, funding for conservation programs, and grants for restoration projects and plant research.",
    shortDescription: "Preserving plant biodiversity for future generations.",
    icon: <FaLeaf />,
    image: "/images/plant-conservation.jpg",
    fundsRaised: 0,
    supporters: 0,
    projectsCompleted: 0,
    website: "https://causeandimpact.org/plant-conservation",
    impactTiers: [
      {
        level: 5000,
        impact: "Provide microgrants for 2 small plant conservation projects",
        allocation: "2 grants of $2,000 + $1,000 admin"
      },
      {
        level: 15000,
        impact: "Support seed banks or arboretum restoration in 3 locations",
        allocation: "$12,000 project funding + $3,000 admin"
      },
      {
        level: 25000,
        impact: "Fund educational awareness resources for plant conservation",
        allocation: "$20,000 education + $5,000 admin"
      },
      {
        level: 35000,
        impact: "Restore degraded habitats with a focused plant conservation project",
        allocation: "$30,000 habitat restoration + $5,000 admin"
      }
    ],
    fallbackPartners: [
      "Missouri Botanical Garden",
      "International Aroid Society",
      "Botanic Gardens Conservation International (BGCI)"
    ],
    updates: [
      {
        id: 1,
        date: "2024-01-15",
        title: "Conservation Initiative Launch",
        content: "Beginning our mission to protect plant biodiversity"
      }
    ]
  },
  {
    id: 3,
    name: "Scientific Advancement Fund",
    categories: ["science", "research"],
    state: "Texas",
    stateTag: "TX",
    description: "Accelerating peer-reviewed, evidence-based scientific research and education that solves real-world problems and advances humanity's knowledge.",
    shortDescription: "Advancing knowledge through scientific research.",
    icon: <FaMicroscope />,
    image: "/images/scientific-advancement.jpg",
    fundsRaised: 0,
    supporters: 0,
    projectsCompleted: 0,
    website: "https://causeandimpact.org/science",
    impactTiers: [
      {
        level: 5000,
        impact: "Award 1 microgrant for peer-reviewed early-stage scientific research",
        allocation: "$4,500 research + $500 admin"
      },
      {
        level: 15000,
        impact: "Develop and distribute educational resources for public science literacy",
        allocation: "$12,000 resources + $3,000 admin"
      },
      {
        level: 25000,
        impact: "Fund 2 small, peer-reviewed research grants",
        allocation: "2 grants of $10,000 + $5,000 admin"
      },
      {
        level: 40000,
        impact: "Provide a comprehensive research grant to a high-impact scientific study",
        allocation: "$35,000 grant + $5,000 admin"
      }
    ],
    fallbackPartners: [
      "American Association for the Advancement of Science (AAAS)",
      "The Kavli Foundation",
      "National Academies of Sciences, Engineering, and Medicine"
    ],
    updates: [
      {
        id: 1,
        date: "2024-01-15",
        title: "Research Fund Launch",
        content: "Initiating support for evidence-based scientific research"
      }
    ]
  }
];

// Helper function to get causes by state
export const getCausesByState = (stateName) => {
  return causes.filter(cause => 
    cause.state === stateName || 
    cause.stateTag === stateName
  );
};

// Helper function to get state name from state tag
export const getStateFromTag = (stateTag) => {
  const cause = causes.find(c => c.stateTag === stateTag);
  return cause ? cause.state : null;
}; 